import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { AStyled } from "../../../../global/buttonsLinks/LinkStyled";
import { useTranslation } from "react-i18next";
import { useBreakpoint } from "../../../../utils/hooks";
import Authorized from "../../../../global/common/Authorized";
import { Role } from "../../../../redux/api-model/organization/company";
import { setIsShortcutsListOpened } from "../../../../redux/ui/ui";

const StyledLink = styled(AStyled)`
  display: block;
  margin-top: 10px;
`;

export default function ShortctsLink(): JSX.Element | null {
  const { t } = useTranslation("shortcuts");
  const dispatch = useDispatch();
  const { isDesktop } = useBreakpoint();

  function onClickHandler() {
    dispatch(setIsShortcutsListOpened(true));
  }

  return isDesktop ? (
    <Authorized visibleFor={[Role.COMPANY_ACCESS, Role.DEPARTMENT_ACCESS]}>
      <StyledLink onClick={onClickHandler}>{t("button")}</StyledLink>
    </Authorized>
  ) : null;
}
